import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {removeItemFromBox} from "../../../services/api/apiNextBox"
import { Popconfirm } from 'antd'


class ButtonRemoveItem extends Component {
    state = {
        loading: false
    }

    _handleClickRemove = async e => {
        e.preventDefault()

        if (this.state.loading) return false

        this.setState({
            loading: true
        })

        const {_id: boxId} = this.props.box
        const {item_number, item_index} = this.props.item

        const barcode = `${item_number}_${item_index}`

        try {
            const {success, message} = await removeItemFromBox(boxId, barcode)

            if (!success) {
                throw new Error(message)
            }

            this.setState({
                loading: false
            }, () => {
                this.props.onRefresh()

                if (typeof this.props.onCheckAll === 'function') {
                    this.props.onCheckAll(false)
                }
            })
        } catch (err) {
            window.alert(err.message)

            this.setState({
                loading: false,
            })
        }
    }

    render() {
        const {loading} = this.state
        const {item} = this.props
        const {item_number, item_index} = {...item}

        // if (status === 'closed') return null

        return (
            <div className="ButtonRemoveItem">
                <Popconfirm
                    placement="topLeft"
                    title={`Xóa item #${item_number}_${item_index} khỏi thùng?`}
                    onConfirm={this._handleClickRemove}
                    disabled={loading}
                    okText="Xóa"
                    cancelText="Hủy"
                >
                    <button disabled={loading}>x</button>
                </Popconfirm>
            </div>
        )
    }
}

ButtonRemoveItem.propTypes = {
    box: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired,
}

export default ButtonRemoveItem
